// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { MonevDokumenResponse } from "./types";

import * as monevActions from "./monev.actions";

export function* getDokumen(
  action: ReturnType<typeof monevActions.getDokumenAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + `dokumen/${action.payload.DOK_ID}`;
    const result: Response = yield call(apiGet, url, token);
    
    if (result.status === 200) {
      const parsed: MonevDokumenResponse = yield call(result.json.bind(result));
      yield put(monevActions.getDokumenAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(monevActions.getDokumenAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(monevActions.getDokumenAsync.failure(parsed));
  }
}

export default function* monevSagaGetDokumen() {
  yield takeEvery(monevActions.getDokumenAsync.request, getDokumen);
}
